// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1yKyF","left":"InfoRow_left__15DHx"};